export default __webpack_public_path__ + "static/media/dashedImage.80b6ea55.svg";